import type { SVGProps } from 'react';
const DawnFlagOM = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <path
      fill="#fff"
      d="M0 2a2 2 0 0 1 2-2h18a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z"
    />
    <path
      fill="#F5F5F5"
      fillRule="evenodd"
      d="M20 .5H2A1.5 1.5 0 0 0 .5 2v12A1.5 1.5 0 0 0 2 15.5h18a1.5 1.5 0 0 0 1.5-1.5V2A1.5 1.5 0 0 0 20 .5M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h18a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z"
      clipRule="evenodd"
    />
    <mask
      id="dawn-flag-OM_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect
        width={21.5}
        height={15.5}
        x={0.25}
        y={0.25}
        fill="#fff"
        stroke="#fff"
        strokeWidth={0.5}
        rx={1.75}
      />
    </mask>
    <g fillRule="evenodd" clipRule="evenodd" mask="url(#dawn-flag-OM_svg__a)">
      <path fill="#138E16" d="M0 16h22v-5.333H0z" />
      <path fill="#ED2B35" d="M0 16h7.333v-5.333H22V5.333H7.333V0H0z" />
      <path
        fill="#fff"
        d="m3.667 3.77-.91 1.352.472-1.567-1.605.12 1.497-.602L2.028 1.87l1.396.817.243-1.62.242 1.62 1.396-.817-1.093 1.203 1.497.602-1.605-.12.472 1.567z"
      />
    </g>
  </svg>
);
export default DawnFlagOM;
